import { RouteObject } from 'react-router-dom';

import ModifyScore from './ModifyScore';

interface RouteObjectWithMeta extends RouteObject {
  name?: string;
  path: string;
}

const examModify: RouteObjectWithMeta[] = [
  {
    path: '/front/examCenter/:examId/modifyScore',
    element: <ModifyScore />,
    name: '修改成绩'
  }
];

export default examModify;
